'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Board,
    Const,
    Piece,
    indexOf = [].indexOf;

Const = require('./const');

Piece = require('./piece');

Board = function () {
  var check_kiki, check_nifu, check_potential;

  var Board = function () {
    function Board() {
      _classCallCheck(this, Board);

      this.rows = Const.COLS;
      this.cols = Const.ROWS;
      // @pieces = ((null for c in [1..Const.COLS]) for r in [1..Const.ROWS])
      this.pieces = [];
      this.kiki = {};
    }

    // @kiki[Const.FIRST] = []
    // @kiki[Const.SECOND] = []


    _createClass(Board, [{
      key: 'set_standard',
      value: function set_standard() {
        this.pieces = [];
        this.pieces.push(new Piece.Ou(Const.FIRST, Const.Status.OMOTE, [3, 3]));
        this.pieces.push(new Piece.Gi(Const.FIRST, Const.Status.MOTIGOMA));
        this.pieces.push(new Piece.Fu(Const.FIRST, Const.Status.MOTIGOMA));
        this.pieces.push(new Piece.Ou(Const.SECOND, Const.Status.OMOTE, [1, 1]));
        this.pieces.push(new Piece.Gi(Const.SECOND, Const.Status.MOTIGOMA));
        this.pieces.push(new Piece.Fu(Const.SECOND, Const.Status.MOTIGOMA));
      }
    }, {
      key: 'add',
      value: function add(piece) {
        this.pieces.push(piece);
      }
    }, {
      key: 'gameover',
      value: function gameover() {
        var kings, v;
        kings = function () {
          var j, len, ref, results;
          ref = this.pieces;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            v = ref[j];
            if (v.kind() === 'Ou' && v.turn === Const.FIRST) {
              results.push(v);
            }
          }
          return results;
        }.call(this);
        switch (kings.length) {
          case 2:
            return Const.FIRST;
          case 0:
            return Const.SECOND;
          default:
            return false;
        }
      }
    }, {
      key: 'display',
      value: function display() {
        var col, i, j, k, koma, l, len, len1, m, n, ref, ref1, ref2, ref3, ref4, row, v;
        ref = this.pieces;
        // console.log(@pieces)
        // console.log(@motigoma)
        for (i = j = 0, len = ref.length; j < len; i = ++j) {
          v = ref[i];
          if (v.turn === Const.SECOND && v.status === Const.Status.MOTIGOMA) {
            if (v != null) {
              process.stdout.write(v.caption());
            }
          }
        }
        process.stdout.write("\n");
        for (col = k = ref1 = this.cols; ref1 <= 1 ? k <= 1 : k >= 1; col = ref1 <= 1 ? ++k : --k) {
          process.stdout.write(" " + col.toString());
        }
        process.stdout.write("\n");
        for (row = l = 1, ref2 = this.rows; 1 <= ref2 ? l <= ref2 : l >= ref2; row = 1 <= ref2 ? ++l : --l) {
          for (col = m = ref3 = this.cols; m >= 1; col = m += -1) {
            // koma = (v for v in @pieces when v.posi? && v.posi.toString() == [col, row].toString())
            koma = function () {
              var len1, n, ref4, results;
              ref4 = this.pieces;
              results = [];
              for (n = 0, len1 = ref4.length; n < len1; n++) {
                v = ref4[n];
                if (v.posi != null && v.posi[0] === col && v.posi[1] === row) {
                  results.push(v);
                }
              }
              return results;
            }.call(this);
            process.stdout.write("|" + (koma.length !== 0 ? koma[0].caption() : " "));
          }
          process.stdout.write("|" + row.toString() + "\n");
        }
        ref4 = this.pieces;
        for (i = n = 0, len1 = ref4.length; n < len1; i = ++n) {
          v = ref4[i];
          if (v.turn === Const.FIRST && v.status === Const.Status.MOTIGOMA) {
            if (v != null) {
              process.stdout.write(v.caption());
            }
          }
        }
        process.stdout.write("\n");
      }
    }, {
      key: 'make_kiki',
      value: function make_kiki(turn) {
        var exclude = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var col, j, k, l, len, ref, ref1, row, selected, v;
        this.kiki[turn] = [];
        selected = function () {
          var j, len, ref, results;
          ref = this.pieces;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            v = ref[j];
            if (v.turn === turn && v.status !== Const.Status.MOTIGOMA && v.kind() !== exclude) {
              results.push(v);
            }
          }
          return results;
        }.call(this);
        for (col = j = 1, ref = this.cols; 1 <= ref ? j <= ref : j >= ref; col = 1 <= ref ? ++j : --j) {
          for (row = k = 1, ref1 = this.rows; 1 <= ref1 ? k <= ref1 : k >= ref1; row = 1 <= ref1 ? ++k : --k) {
            for (l = 0, len = selected.length; l < len; l++) {
              v = selected[l];
              if (check_kiki.call(this, v, [row, col])) {
                this.kiki[turn].push([row, col]);
                break;
              }
            }
          }
        }
      }
    }, {
      key: 'check_move',
      value: function check_move(piece, d_posi) {
        var buf, dest, force_promo, j, k, l, len, o, ref, ref1, ref2, ref3, ref4, results, results1, v;
        // console.log("check_move")
        force_promo = false;
        // dest = null
        // dest = (v for v in @pieces when v.posi? && v.posi.toString() == d_posi.toString())
        dest = function () {
          var j, len, ref, results;
          ref = this.pieces;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            v = ref[j];
            if (v.posi != null && v.posi[0] === d_posi[0] && v.posi[1] === d_posi[1]) {
              results.push(v);
            }
          }
          return results;
        }.call(this);
        if (piece.status === Const.Status.MOTIGOMA) {
          if (dest.length !== 0) {
            // 駒が存在しているところに駒を打とうとした
            console.log("--- Parameter Error in Board.check_move ---");
          }
          if (dest.length === 0 && check_potential.call(this, piece, d_posi)) {
            // 二歩チェック
            if (piece.kind() === 'Fu' && check_nifu.call(this, piece, d_posi)) {
              // console.log("check0")
              return false;
            } else {
              // console.log("check-1")
              return true;
            }
          } else {
            // console.log("check00")
            return false;
          }
        } else {
          if (!check_potential.call(this, piece, d_posi)) {
            if (this.check_promotion(piece, d_posi)) {
              force_promo = true;
            } else {
              // console.log("check00-1")
              return false;
            }
          }
        }
        ref = eval("Piece." + piece.kind()).getD(piece.turn, piece.status);
        // console.log("--- Error in Board.check_move ---")
        for (j = 0, len = ref.length; j < len; j++) {
          v = ref[j];
          buf = [].concat(piece.posi);
          buf[0] += v.xd;
          buf[1] += v.yd;
          // if (buf.toString() == d_posi.toString())
          if (buf[0] === d_posi[0] && buf[1] === d_posi[1]) {
            if (dest.length !== 0) {
              if (piece.turn !== dest[0].turn) {
                if (force_promo) {
                  piece.status = Const.Status.URA;
                }
                // console.log("check1")
                return true;
              }
            } else {
              if (force_promo) {
                piece.status = Const.Status.URA;
              }
              // console.log("check2")
              return true;
            }
          }
          if (v.series) {
            while ((ref1 = buf[0], indexOf.call(function () {
              results = [];
              for (var k = 1, ref2 = this.cols; 1 <= ref2 ? k <= ref2 : k >= ref2; 1 <= ref2 ? k++ : k--) {
                results.push(k);
              }
              return results;
            }.apply(this), ref1) >= 0) && (ref3 = buf[1], indexOf.call(function () {
              results1 = [];
              for (var l = 1, ref4 = this.rows; 1 <= ref4 ? l <= ref4 : l >= ref4; 1 <= ref4 ? l++ : l--) {
                results1.push(l);
              }
              return results1;
            }.apply(this), ref3) >= 0)) {
              // if (buf.toString() == d_posi.toString())
              if (buf[0] === d_posi[0] && buf[1] === d_posi[1]) {
                if (dest.length === 0) {
                  if (force_promo) {
                    piece.status = Const.Status.URA;
                  }
                  // console.log("check3")
                  return true;
                } else {
                  if (piece.turn !== dest[0].turn) {
                    if (force_promo) {
                      piece.status = Const.Status.URA;
                    }
                    // console.log("check4")
                    return true;
                  } else {
                    break;
                  }
                }
              } else {
                if (function () {
                  var k, len1, ref1, results;
                  ref1 = this.pieces;
                  results = [];
                  for (k = 0, len1 = ref1.length; k < len1; k++) {
                    o = ref1[k];
                    if (o.posi != null && o.posi[0] === buf[0] && o.posi[1] === buf[1]) {
                      results.push(o);
                    }
                  }
                  return results;
                }.call(this)[0] != null) {
                  // break if (o for o in @pieces when o.posi? && o.posi.toString() == buf.toString())[0]?
                  break;
                }
              }
              buf[0] += v.xd;
              buf[1] += v.yd;
            }
          }
        }
        // console.log("check5")
        return false;
      }

      // 成れるかどうか判定

    }, {
      key: 'check_promotion',
      value: function check_promotion(piece, d_posi) {
        var ref;
        if (piece.status !== Const.Status.OMOTE) {
          // posi = v for v in @pieces when (k ==
          return false;
        }
        if ((ref = piece.kind()) === 'Ou' || ref === 'Ki') {
          return false;
        }
        switch (piece.turn) {
          case Const.FIRST:
            if (piece.posi[1] <= Board.promotion_line[0] || d_posi[1] <= Board.promotion_line[0]) {
              return true;
            }
            break;
          case Const.SECOND:
            if (piece.posi[1] >= Board.promotion_line[1] || d_posi[1] >= Board.promotion_line[1]) {
              return true;
            }
        }
        return false;
      }
    }, {
      key: 'move_capture',
      value: function move_capture(piece, d_posi) {
        var dest, s_posi, v;
        // dest = (v for v in @pieces when v.posi? && v.posi.toString() == d_posi.toString())
        dest = function () {
          var j, len, ref, results;
          ref = this.pieces;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            v = ref[j];
            if (v.posi != null && v.posi[0] === d_posi[0] && v.posi[1] === d_posi[1]) {
              results.push(v);
            }
          }
          return results;
        }.call(this);
        if (dest.length !== 0) {
          dest[0].status = Const.Status.MOTIGOMA;
          dest[0].setTurn(piece.turn);
          dest[0].posi = [];
        } else {
          if (piece.status === Const.Status.MOTIGOMA) {
            piece.status = Const.Status.OMOTE;
          }
        }
        s_posi = [].concat(piece.posi);
        piece.posi = [].concat(d_posi);
        return s_posi;
      }
    }, {
      key: 'check_utifudume',
      value: function check_utifudume(piece, d_posi) {
        var dest, j, k, l, len, o, oppo, oppo_king, org, ref, ref1, ref2, ref3, ref4, results, results1, v, w;
        // console.log("check_utifudume")
        oppo = piece.turn === Const.FIRST ? Const.SECOND : Const.FIRST;
        oppo_king = function () {
          var j, len, ref, results;
          ref = this.pieces;
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            v = ref[j];
            if (v.turn === oppo && v.kind() === 'Ou') {
              results.push(v);
            }
          }
          return results;
        }.call(this)[0];
        // buf = [].concat(d_posi)
        // buf[0] += eval("Piece."+piece.kind()).getD(piece.turn, piece.status)[0].xd
        // buf[1] += eval("Piece."+piece.kind()).getD(piece.turn, piece.status)[0].yd
        //1,打ち歩による王手
        // check = piece.status == Const.Status.MOTIGOMA && piece.kind() == 'Fu' && oppo_king.posi[0] == buf[0] && oppo_king.posi[1] == buf[1]
        // console.log("check1")
        // return false unless check

        //2,打ち歩を玉以外の味方の駒で取ることが出来ない
        this.make_kiki(oppo, 'Ou');
        // if (d_posi.toString() in @kiki[oppo].map (o) -> o.toString())
        if (function () {
          var j, len, ref, results;
          ref = this.kiki[oppo];
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            o = ref[j];
            if (o[0] === d_posi[0] && o[1] === d_posi[1]) {
              results.push(o);
            }
          }
          return results;
        }.call(this)[0] != null) {
          // console.log("check2")
          return false;
        }
        //3,玉が逃げることも出来ないし、打たれた歩に相手の駒の利きがある（玉で取ることも出来ない）
        this.make_kiki(piece.turn);
        org = [].concat(oppo_king.posi);
        ref = Piece.Ou.getD(oppo_king.turn, oppo_king.status);
        for (j = 0, len = ref.length; j < len; j++) {
          v = ref[j];
          dest = [org[0] + v.xd, org[1] + v.yd];
          if (!((ref1 = dest[0], indexOf.call(function () {
            results = [];
            for (var k = 1, ref2 = this.cols; 1 <= ref2 ? k <= ref2 : k >= ref2; 1 <= ref2 ? k++ : k--) {
              results.push(k);
            }
            return results;
          }.apply(this), ref1) >= 0) && (ref3 = dest[1], indexOf.call(function () {
            results1 = [];
            for (var l = 1, ref4 = this.rows; 1 <= ref4 ? l <= ref4 : l >= ref4; 1 <= ref4 ? l++ : l--) {
              results1.push(l);
            }
            return results1;
          }.apply(this), ref3) >= 0))) {
            continue;
          }
          // if (dest.toString() in @kiki[piece.turn].map (o) -> o.toString())
          if (function () {
            var len1, m, ref5, results2;
            ref5 = this.kiki[piece.turn];
            results2 = [];
            for (m = 0, len1 = ref5.length; m < len1; m++) {
              o = ref5[m];
              if (o[0] === dest[0] && o[1] === dest[1]) {
                results2.push(o);
              }
            }
            return results2;
          }.call(this)[0] != null) {
            continue;
          } else {
            if (function () {
              var len1, m, ref5, results2;
              ref5 = this.pieces;
              results2 = [];
              for (m = 0, len1 = ref5.length; m < len1; m++) {
                w = ref5[m];
                if (w.posi != null && w.posi[0] === dest[0] && w.posi[1] === dest[1]) {
                  results2.push(w);
                }
              }
              return results2;
            }.call(this)[0] == null) {
              return false;
            }
          }
        }
        // if @check_move(oppo_king, dest)
        //     # console.log("check3")
        //     return false
        // console.log("check4")
        return true;
      }
    }]);

    return Board;
  }();

  ;

  Board.promotion_line = [1, 3];

  check_nifu = function check_nifu(piece, d_posi) {
    var v;
    return function () {
      var j, len, ref, results;
      ref = this.pieces;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        v = ref[j];
        if (v.posi != null && v.posi[0] === d_posi[0] && v.kind() === 'Fu' && v.status === Const.Status.OMOTE && v.turn === piece.turn) {
          results.push(v);
        }
      }
      return results;
    }.call(this)[0] != null;
  };

  // 打った後、指した後に移動可能な場所が無い場合falseを返す
  check_potential = function check_potential(piece, d_posi) {
    var j, len, ref, v;
    ref = eval("Piece." + piece.kind()).getD(piece.turn, piece.status);
    for (j = 0, len = ref.length; j < len; j++) {
      v = ref[j];
      if (d_posi[0] + v.xd > 0 && d_posi[1] + v.yd > 0 && d_posi[0] + v.xd <= this.cols && d_posi[1] + v.yd <= this.rows) {
        return true;
      }
    }
    return false;
  };

  check_kiki = function check_kiki(piece, d_posi) {
    var buf, j, k, l, len, o, ref, ref1, ref2, ref3, ref4, results, results1, v;
    ref = eval("Piece." + piece.kind()).getD(piece.turn, piece.status);
    for (j = 0, len = ref.length; j < len; j++) {
      v = ref[j];
      buf = [].concat(piece.posi);
      while (true) {
        buf[0] += v.xd;
        buf[1] += v.yd;
        if (buf[0] === d_posi[0] && buf[1] === d_posi[1]) {
          return true;
        }
        if (function () {
          var k, len1, ref1, results;
          ref1 = this.pieces;
          results = [];
          for (k = 0, len1 = ref1.length; k < len1; k++) {
            o = ref1[k];
            if (o.posi != null && o.posi[0] === buf[0] && o.posi[1] === buf[1]) {
              results.push(o);
            }
          }
          return results;
        }.call(this)[0] != null) {
          // temp = (o for o in @pieces when o.posi? && o.posi[0] == buf[0] && o.posi[1] == buf[1])[0]
          // break if temp?
          // break if (buf.toString() in (o for o in @pieces when o.posi?).map (it) -> it.posi.toString())
          break;
        }
        if (!(v.series && (ref1 = buf[0], indexOf.call(function () {
          results = [];
          for (var k = 1, ref2 = this.cols; 1 <= ref2 ? k <= ref2 : k >= ref2; 1 <= ref2 ? k++ : k--) {
            results.push(k);
          }
          return results;
        }.apply(this), ref1) >= 0) && (ref3 = buf[1], indexOf.call(function () {
          results1 = [];
          for (var l = 1, ref4 = this.rows; 1 <= ref4 ? l <= ref4 : l >= ref4; 1 <= ref4 ? l++ : l--) {
            results1.push(l);
          }
          return results1;
        }.apply(this), ref3) >= 0))) {
          break;
        }
      }
    }
    return false;
  };

  return Board;
}();

module.exports = Board;


//////////////////
// WEBPACK FOOTER
// ./board.coffee
// module id = 310
// module chunks = 0